import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { DataQualityResponse } from './DataQuality.types'

const fetchDataQuality = async (): Promise<DataQualityResponse[]> => {
  const { data } = await request({
    url: '/plan/data-quality',
    method: 'get',
  })
  return data?.data || []
}

export const useDataQuality = () => {
  return useQuery(['data-quality'], () => fetchDataQuality(), {
    select: (data: DataQualityResponse[]) => {
      // Create a map for efficient lookup by workCentreCode
      const dataQualityMap = new Map<string, DataQualityResponse>()
      data.forEach((item) => {
        dataQualityMap.set(item.workCentreCode, item)
      })
      return {
        data,
        dataQualityMap,
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  })
}
